import axios from 'axios';
import { Configuration, ProductOrderApiFactory, DeliveryApiFactory } from '@cdaas/api-clients/dist/order-openapi';

const orderConfig = new Configuration({
  basePath: process.env.REACT_APP_ORDER_SERVICE_URL,
});

export const orderProductOrderClient = ProductOrderApiFactory(orderConfig, undefined, axios);
export const orderDeliveryClient = DeliveryApiFactory(orderConfig, undefined, axios);
